import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from './pages/Main'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import About from './pages/About'
import Fields from './pages/Fields'
import Corporate from "./pages/fields/Corporate";
import Litigation from "./pages/fields/Litigation";
import PersonalInjury from "./pages/fields/Personal-injury";
import AccidentBenefit from "./pages/fields/PI/AccidentBenefit";
import BicycleAccidents from "./pages/fields/PI/BicycleAccidents";
import CarAccidents from "./pages/fields/PI/CarAccidents";
import CatastrophicInjuries from "./pages/fields/PI/CatastrophicInjuries";
import ChronicPain from "./pages/fields/PI/ChronicPain";
import Disability from "./pages/fields/PI/Disability";
import FatalAccident from "./pages/fields/PI/FatalAccident";
import Insurance from "./pages/fields/PI/Insurance";
import Motorcycle from "./pages/fields/PI/Motorcycle";
import PublicTransit from "./pages/fields/PI/PublicTransit";
import SlipAndFall from "./pages/fields/PI/SlipAndFall";
import WrongfulDeath from "./pages/fields/PI/WrongfulDeath";
import RealEstate from "./pages/fields/Real-estate";
import Team from './pages/Team'
import GeorgeCorsianos from './pages/members/GeorgeCorsianos'
import JacobLee from './pages/members/JacobLee'
import MickVashishth from './pages/members/MickVashishth'
import BurkeHeather from './pages/members/BurkeHeather'
import HarissonGiovannetti from './pages/members/HarrisonGiovannetti'
import CathyVashishth from './pages/members/CathyVashishth'
import PhilGuarragi from './pages/members/PhilGuarragi'
import VaraLeung from './pages/members/VaraLeung'
import SaraJane from './pages/members/SaraJane'
import Contact from "./pages/Contact";
import './App.css';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function ScrollToTop() {
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'auto', // optional: makes scroll smooth
      });
    }, [pathname]);
  
    return null;
  }

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/terms-of-use" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/about" element={<About />} />
        <Route path="/fields-of-expertise" element={<Fields />} />
          <Route path="/fields-of-expertise/corporate-and-commercial-law" element={<Corporate />} />
          <Route path="/fields-of-expertise/litigation" element={<Litigation />} />
          <Route path="/fields-of-expertise/personal-injury" element={<PersonalInjury />} />
            <Route path="/fields-of-expertise/personal-injury/car-accidents" element={<CarAccidents />} />
            <Route path="/fields-of-expertise/personal-injury/slip-and-fall-accidents" element={<SlipAndFall />} />
            <Route path="/fields-of-expertise/personal-injury/motorcycle-accidents" element={<Motorcycle />} />
            <Route path="/fields-of-expertise/personal-injury/bicycle-accidents" element={<BicycleAccidents />} />
            <Route path="/fields-of-expertise/personal-injury/public-transit-injuries" element={<PublicTransit />} />
            <Route path="/fields-of-expertise/personal-injury/catastrophic-injuries" element={<CatastrophicInjuries />} />
            <Route path="/fields-of-expertise/personal-injury/wrongful-death" element={<WrongfulDeath />} />
            <Route path="/fields-of-expertise/personal-injury/long-term-disability-claims" element={<Disability />} />
            <Route path="/fields-of-expertise/personal-injury/accident-benefit-claims" element={<AccidentBenefit />} />
            <Route path="/fields-of-expertise/personal-injury/insurance-litigation" element={<Insurance />} />
            <Route path="/fields-of-expertise/personal-injury/fatal-accident-compensation-claims" element={<FatalAccident />} />
            <Route path="/fields-of-expertise/personal-injury/chronic-pain" element={<ChronicPain />} />
          <Route path="/fields-of-expertise/real-estate" element={<RealEstate />} />
        <Route path="/our-team" element={<Team />} />
          <Route path="/our-team/george-corsianos" element={<GeorgeCorsianos />} />
          <Route path="/our-team/jacob-lee" element={<JacobLee />} />
          <Route path="/our-team/mick-vashishth" element={<MickVashishth />} />
          <Route path="/our-team/burke-heather" element={<BurkeHeather />} />
          <Route path="/our-team/harrison-giovannetti" element={<HarissonGiovannetti />} />
          <Route path="/our-team/cathy-vashishth" element={<CathyVashishth />} />
          <Route path="/our-team/phil-guarragi" element={<PhilGuarragi />} />
          <Route path="/our-team/vara-leung" element={<VaraLeung />} />
          <Route path="/our-team/sara-jane-carter" element={<SaraJane />} />
        <Route path="/contact-us" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
